import React, { useState } from 'react';

const QuickServiceForm = ({ onSubmit, onCancel, loading }) => {
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    description: '',
    base_price: '',
    duration_minutes: '',
    labor_included: true
  });

  const [errors, setErrors] = useState({});

  const categories = [
    'Entretien',
    'Réparation',
    'Diagnostic',
    'Carrosserie',
    'Pneumatiques',
    'Climatisation',
    'Électronique'
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Effacer l'erreur pour ce champ
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Le nom de la prestation est requis';
    }

    if (!formData.category) {
      newErrors.category = 'La catégorie est requise';
    }

    if (!formData.base_price || isNaN(parseFloat(formData.base_price)) || parseFloat(formData.base_price) < 0) {
      newErrors.base_price = 'Le prix doit être un nombre positif';
    }

    if (formData.duration_minutes && (isNaN(parseInt(formData.duration_minutes)) || parseInt(formData.duration_minutes) < 0)) {
      newErrors.duration_minutes = 'La durée doit être un nombre positif en minutes';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    try {
      const serviceData = {
        ...formData,
        base_price: parseFloat(formData.base_price),
        duration_minutes: formData.duration_minutes ? parseInt(formData.duration_minutes) : null,
        active: true // Nouvelle prestation active par défaut
      };

      await onSubmit(serviceData);
    } catch (error) {
      console.error('Erreur lors de la création de la prestation:', error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content quick-service-modal">
        <div className="modal-header">
          <h3>Nouvelle Prestation Rapide</h3>
          <button className="close-btn" onClick={onCancel} type="button">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="quick-service-form">
          <div className="form-grid">
            <div className="form-group">
              <label htmlFor="name">Nom de la prestation *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={errors.name ? 'error' : ''}
                placeholder="Ex: Vidange moteur, Changement plaquettes..."
                autoFocus
              />
              {errors.name && <span className="error-message">{errors.name}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="category">Catégorie *</label>
              <select
                id="category"
                name="category"
                value={formData.category}
                onChange={handleChange}
                className={errors.category ? 'error' : ''}
              >
                <option value="">Sélectionner une catégorie</option>
                {categories.map(category => (
                  <option key={category} value={category}>
                    {category}
                  </option>
                ))}
              </select>
              {errors.category && <span className="error-message">{errors.category}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="base_price">Prix de base (€) *</label>
              <input
                type="number"
                step="0.01"
                id="base_price"
                name="base_price"
                value={formData.base_price}
                onChange={handleChange}
                className={errors.base_price ? 'error' : ''}
                placeholder="0.00"
                min="0"
              />
              {errors.base_price && <span className="error-message">{errors.base_price}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="duration_minutes">Durée (minutes)</label>
              <input
                type="number"
                id="duration_minutes"
                name="duration_minutes"
                value={formData.duration_minutes}
                onChange={handleChange}
                className={errors.duration_minutes ? 'error' : ''}
                placeholder="60"
                min="0"
              />
              {errors.duration_minutes && <span className="error-message">{errors.duration_minutes}</span>}
            </div>

            <div className="form-group full-width">
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Description détaillée de la prestation..."
                rows="3"
              />
            </div>

            <div className="form-group full-width">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="labor_included"
                  checked={formData.labor_included}
                  onChange={handleChange}
                />
                <span className="checkbox-text">Main d'œuvre incluse</span>
              </label>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" onClick={onCancel} className="btn-secondary">
              Annuler
            </button>
            <button type="submit" disabled={loading} className="btn-primary">
              {loading ? 'Création...' : 'Créer Prestation'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QuickServiceForm;
